@let quoteTextResponse = this.quoteTextId();
@let authorResponse = this.authorId();

<div class="app-component-container">
    <div class="quote-container">
        <div class="quote-content">
            @if(quoteTextResponse.success){
                <app-editable-text [customClass]="'custom-title-large quote'" [elemId]="quoteTextResponse.payload"></app-editable-text>     
            }
            <div class="author">
                @if(authorResponse.success){
                    <app-editable-text [elemId]="authorResponse.payload"></app-editable-text>
                }
            </div>
        </div>
    </div>
</div>
